import CustomerTypeSelection from '../../const/customer_type';

export const getAgeByCustomerType = (adultAge, medicalAge, customerTypeAllow) => {
  if (CustomerTypeSelection.ALL === customerTypeAllow) {
    return adultAge;
  }

  if (CustomerTypeSelection.MEDICAL === customerTypeAllow) {
    return medicalAge;
  }
  
  if (CustomerTypeSelection.ADULT === customerTypeAllow) {
    return adultAge;
  }
}



// WEBPACK FOOTER //
// ./src/components/AgeConfirmModal/age_util.js